module.exports = __webpack_public_path__ + "media/images/icons/trash-5e7952bc7747978bf74657ead28c181a.svg";